module.exports = __webpack_public_path__ + "img/SA3200D.3cb85a8e.png";